import React, { useEffect, useReducer, useState, useCallback, useRef } from 'react';
import { Scheduler } from 'devextreme-react/scheduler';
import * as actions from '../../../actions/dashboard';
import _ from 'lodash'
import dashboardReducer from '../../../reducers/dashboard';
import { CONFIG } from './config'
import { GetWeek, timeConverter } from './utils'
import moment from 'moment';
import { set, get } from '../../../common/utils'
import SelectBox from 'devextreme-react/select-box';
import { confirm, alert } from 'devextreme/ui/dialog';
import Tooltip from './Tooltip.js';
const initialState = { calendarInfo: null, calendarEventTypes: null }

export default ({ siteId, tierId, isEditable }) => {
    const [state, dispatch] = useReducer(dashboardReducer, initialState);
    const { calendarInfo, calendarEventTypes } = state;
    const fetchProps = `siteId=${siteId}&tierId=${tierId}`
    const [currentView, setCurrentView] = useState('month');
    const [dateRange, setDateRange] = useState({
        fromDate: '',
        toDate: ''
    });
    const scheduler = useRef(null);

    useEffect(() => {
        actions.fetchCalendarEventTypes(dispatch, siteId);
        actions.fetchCalendarPlan(dispatch, fetchProps);
        if (!tierId) actions.fetchTiersList(dispatch, siteId);

    }, []);


    useEffect(() => {
        if (calendarInfo && calendarInfo.length) {
            calendarInfo.forEach(val => {
                let sDate = new Date(val.startDate + ' UTC')
                let endDate = new Date(val.endDate + ' UTC')

                val.startDate = sDate
                val.endDate = endDate
            })
        }
    }, [calendarInfo])


    useEffect(() => { set('tiersList', state.tiersList) }, [state.tiersList]);

    let dataTier = get('tiersList');
    let calendarEventTypeList = ['Others'];
    if (calendarEventTypes && calendarEventTypes.length > 0) {
        let calEventTypes = calendarEventTypes.map(d => d.calendarEventType)
        calendarEventTypeList = [...calEventTypes, 'Others']
    }

    const getTierLevels = () => _.uniq(_.map(state.tiersList, d => d.tierLevel))
    const onRowUpdated = (data) => {
        let { id, category, description, startDate, endDate, location, text, meetingURL, tierLevel } = data.newData;
        let sDate = new Date(startDate)
        let eDate = new Date(endDate)

        let planUpdate = {
            "id": id,
            "tierID": tierId == '' ? 0 : parseInt(tierId),
            "tierLevel": tierLevel,
            "category": category,
            "ActionDescription": description,
            "startDate": timeConverter(sDate.toISOString()),
            "endDate": timeConverter(eDate.toISOString()),
            "location": location,
            "sitecode": siteId,
            "ActionTitle": text,
            "meetingURL": meetingURL,
            "Archive": "N"
        }
        actions.updateCalendarPlan(dispatch, planUpdate, fetchProps);
    }

    const onRowInserted = (data) => {
        let { category, description, startDate, endDate, location, text, meetingURL, tierLevel } = data.appointmentData;
        let sDate = new Date(startDate)
        let eDate = new Date(endDate)

        let planUpdate = {
            "tierID": tierId == '' ? 0 : parseInt(tierId),
            "tierLevel": tierLevel,
            "category": category,
            "ActionDescription": description,
            "startDate": timeConverter(sDate.toISOString()),
            "endDate": timeConverter(eDate.toISOString()),
            "location": location,
            "sitecode": siteId,
            "ActionTitle": text,
            "meetingURL": meetingURL,
            "Archive": "N"
        }

        actions.addCalendarPlan(dispatch, planUpdate, fetchProps)
    }
    const onValueChanged = (e) => {
        if (!tierId) {
            if (e.value == 'All') {
                scheduler.current.instance._dataSource.filter(s => { return ('all' === 'all') });
                scheduler.current.instance._dataSource.load()
            } else {
                scheduler.current.instance._dataSource.filter(s => { return (s.tierLevel === e.value) });
                scheduler.current.instance._dataSource.load()
            }

        }
    }

    const onAppointmentFormOpening = (e) => {
        let { form } = e;

        if (e.appointmentData.location === 'Action Rail') {
            form.option(
                "items",
                [{
                    itemType: "group",
                    colCount: 1,
                    colSpan: 2,
                    items: [
                        {
                            dataField: "id",
                            visible: false,
                        },
                        {
                            dataField: "text",
                            label: {
                                text: "Title"
                            },
                            dataType: "string",
                            disabled: true,
                        },
                        {
                            label: {
                                text: "Location"
                            },
                            dataField: "location",
                            dataType: "string",
                            disabled: true,

                        },
                        {
                            dataField: "endDate",
                            dataType: "string",
                            disabled: true,
                        },
                        {
                            label: {
                                text: "Description"
                            },
                            dataField: "description",
                            dataType: "string",
                            disabled: true,
                        },
                        {
                            dataField: "tierLevel",
                            label: {
                                text: "Tier Level"
                            },
                            dataType: "string",
                            disabled: true,
                            visible: (!tierId && true),
                        }
                    ],
                }],
            );
        }
        else {
            form.option(
                "items",
                [{
                    itemType: "group",
                    colCount: 1,
                    colSpan: 2,
                    items: [
                        {
                            dataField: "id",
                            visible: false,
                        },
                        {
                            dataField: "text",
                            label: {
                                text: "Title"
                            },
                            editorType: "dxTextBox",
                            editorOptions: {
                                width: "100%",
                            },
                            validationRules: [{ type: "required" }],
                        },
                        {
                            label: {
                                text: "Location"
                            },
                            editorType: "dxTextBox",
                            dataField: "location",
                            editorOptions: {
                                width: "100%",
                            },
                            validationRules: [{ type: "required" }],
                        },

                        {
                            dataField: "startDate",
                            editorType: "dxDateBox",
                            editorOptions: {
                                width: "100%",
                                type: 'datetime',
                                //  useMaskBehavior: true,


                            },
                            validationRules: [{ type: "required" }],

                        },
                        {
                            dataField: "endDate",
                            editorType: "dxDateBox",
                            editorOptions: {
                                width: "100%",
                                type: 'datetime',
                                //   useMaskBehavior: true
                            },
                            validationRules: [{ type: "required" }],

                        },
                        {
                            label: {
                                text: "Description"
                            },
                            editorType: "dxTextArea",
                            dataField: "description",
                            editorOptions: {
                                width: "100%",
                            }
                        },
                        {
                            label: {
                                text: "Activity"
                            },
                            editorType: "dxSelectBox",
                            dataField: "category",
                            editorOptions: {
                                items: calendarEventTypeList,
                            },
                            validationRules: [{ type: "required" }],
                        }
                        ,
                        {
                            dataField: "meetingURL",
                            label: {
                                text: "Meeting URL"
                            },
                            editorType: "dxTextBox"
                        }
                        ,
                        {
                            dataField: "tierLevel",
                            label: {
                                text: "Tier Level"
                            },
                            editorType: "dxSelectBox",
                            editorOptions: {
                                dataSource: (!tierId && getTierLevels()),

                            },
                            visible: (!tierId && true),
                            validationRules: [{ type: "required" }],

                        }
                    ],
                }],
            );
        }

    }

    const onRowRemoved = (data) => {
        actions.deleteCalendarPlan(dispatch, data.appointmentData.id, fetchProps)
    }

    const onPlanDel = (id) => {
        actions.deleteCalendarPlan(dispatch, id, fetchProps)
    }

    const toolTipComp = (e, b) => {
        if (e !== undefined && e.data.appointmentData.location === 'Action Rail') {
            let data = e.data.appointmentData
            return (
                <>
                    <div className="dx-tooltip-appointment-item">
                        <div class="dx-tooltip-appointment-item-marker">
                            <div class="dx-tooltip-appointment-item-marker-body"></div>
                        </div>
                        <div class="dx-tooltip-appointment-item-content">
                            <div class="dx-tooltip-appointment-item-content-subject">{data.text}</div>
                            <div class="dx-tooltip-appointment-item-content-date">
                                {`${moment(new Date(data.endDate)).format('MMM DD, LT')} `}
                            </div>
                        </div>
                    </div>
                </>
            )
        }
        else {
            let data = e.data.appointmentData
            return (
                <>
                    <div class="dx-tooltip-appointment-item">
                        <div class="dx-tooltip-appointment-item-marker">
                            <div class="dx-tooltip-appointment-item-marker-body"></div>
                        </div>
                        <div class="dx-tooltip-appointment-item-content">
                            <div class="dx-tooltip-appointment-item-content-subject">{data.text}</div>
                            <div class="dx-tooltip-appointment-item-content-date">
                                {`${moment(new Date(data.startDate)).format('MMM DD, LT')} - ${moment(new Date(data.endDate)).format('MMM DD, LT')} `}
                            </div>
                        </div>
                        <div class="dx-tooltip-appointment-item-delete-button-container">
                            <div class="dx-widget dx-button dx-button-mode-text dx-button-normal dx-button-has-icon dx-tooltip-appointment-item-delete-button" role="button" aria-label="trash" tabindex="0">
                                <div class="dx-button-content">
                                    <i class="dx-icon dx-icon-trash"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                </>
            );
        }

    }

    const dataCellTemplate = (cellData, index, container) => {
        let date = cellData.startDate;
        let d = new Date(date);
        let cellText = '';
        if (currentView === "month") {
            if (date.getDay() == 0) {
                let weekText = "W" + GetWeek(d);
                cellText = "<div class='weekText'><h4>" + weekText + "</h4></div>" + "<div class='dayText'>" + cellData.text + "</div>"

                return cellData.text = cellText;
            }
            cellText = "<div class='dayText'>" + cellData.text + "</div>"
            return cellData.text = cellText;
        }
        else if (currentView === "week") {
            if (container.classList[0] === "dx-scheduler-first-group-cell") {
                if (container.className !== "dx-scheduler-first-group-cell dx-scheduler-cell-sizes-horizontal dx-scheduler-cell-sizes-vertical dx-scheduler-date-table-cell ") {
                    let weekText = "W" + GetWeek(d);
                    cellText = "<div class='weekText'><h4>" + weekText + "</h4></div>" + "<div class='dayText'>" + cellData.text + "</div>"

                    return cellData.text = cellText;
                }
            }
            cellText = "<div class='dayText'>" + cellData.text + "</div>"
            return cellData.text = cellText;
        }
    }
    const appointmentComp = (e) => {
        const { appointmentData } = e.data;
        return (<div className="plann-cell">
            <button onClick={() => alert(appointmentData.meetingUrl)}>Launch meeting</button>
            <div> {appointmentData.text}</div>
        </div>)
    }
    const [currentDate, setCurrentDate] = useState(new Date());

    const onExporting = e => {
        let dateS = e.target.parentElement.parentElement.nextElementSibling.firstChild.firstElementChild.innerText;//e.target.parentElement.nextElementSibling.firstChild.firstElementChild.innerText;
        let fromDate = '';
        let toDate = '';

        if (!dateS.toString().includes('-')) {
            let dt = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();

            fromDate = `${1}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`;
            toDate = `${dt}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`;
        }
        else {
            fromDate = moment(new Date(dateS.toString().split('-')[0]),
                'DD-MM-YYYY')
                .format('DD/MM/YYYY').split('T')[0];
            toDate = moment(new Date(dateS.toString().split('-')[1]),
                'DD-MM-YYYY')
                .format('DD/MM/YYYY').split('T')[0];
        }

        actions.exportData(`digitaltier/exportCalendarDetails?siteId=${siteId}&tierId=${tierId}&fromDate=${fromDate}&toDate=${toDate}`, 'Honeywell Calendar');
        e.cancel = true;
    }

    const onOptionChanged = useCallback((e) => {
        if (e.name === 'currentView') {
            setCurrentView(e.value);
        }
        if (e.name === 'currentDate') {
            setCurrentDate(e.value);
        }
    }, [setCurrentDate, setCurrentView]);
    let nCalConfig = { ...CONFIG }

    if (!isEditable) {
        nCalConfig.editing.allowUpdating = false
        nCalConfig.editing.allowAdding = false
        nCalConfig.editing.allowDeleting = false
    } else {
        nCalConfig.editing.allowUpdating = true
        nCalConfig.editing.allowAdding = true
        nCalConfig.editing.allowDeleting = true
    }

    const customizeDateNavigatorText = useCallback((e) => {
        const formatOptions = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        };
        const formattedStartDate = e.startDate.toLocaleString('en', formatOptions);
        const formattedEndDate = e.endDate.toLocaleString('en', formatOptions);

        if (currentView === 'month')
            return e.startDate.toLocaleString('en', { year: 'numeric', month: 'long' });

        return formattedStartDate + ' - ' + formattedEndDate;
    }, [currentView]);

    const onAppointmentRendered = (e) => {
        return (
            e.appointmentElement.style.backgroundColor = e.appointmentData.color,
            e.appointmentElement.style.color = "black"

        );
    }

    const appointmentTooltip = useCallback((props) => {
        const schedulerRef = scheduler.current;

        // NOTE: You can use props.appointmentData.resouceId to obtain resource color
        const color = '#337ab7';
        const isAppointmentDisabled = false;// data.appointmentData.disabled;
        const isDeleteAllowed = props.appointmentData.location !== 'Action Rail' ?? true;
        const isDeleteButtonExist = !isAppointmentDisabled && isDeleteAllowed;
        const onDeleteButtonClick = (e) => {
            e.event.stopPropagation();
            confirm("Are you sure you want to delete selected event?", "Confirm delete")
                .then((res) => {
                    if (res) {
                        schedulerRef.instance.deleteAppointment(props.appointmentData);
                        schedulerRef.instance.hideAppointmentTooltip();
                    }
                    else {
                        schedulerRef.instance.hideAppointmentTooltip();
                    }
                })
        };

        return (
            <Tooltip
                {...props}
                isDeleteButtonExist={isDeleteButtonExist}
                onDeleteButtonClick={onDeleteButtonClick}
                color={color}
            />
        );
    }, []);
    return (
        <div className="nexuscalendar w-100">
            {!tierId &&
                <div className="tier-level-calendar">
                    <span>
                        <SelectBox
                            dataSource={['All', ...getTierLevels()]}
                            placeholder="All"
                            onValueChanged={onValueChanged}
                        />
                    </span>
                </div>
            }
            <div className="export-calendar" >
                <span onClick={e => onExporting(e)}>
                    <i className="fas fa-file-export" ></i></span>
            </div>
            {calendarInfo &&
                <Scheduler
                    ref={scheduler}
                    dataSource={calendarInfo}
                    defaultCurrentView="month"
                    //crossScrollingEnabled={true}
                    cellDuration={20}
                    {...nCalConfig}
                    width="100%"
                    onAppointmentUpdating={onRowUpdated}
                    onAppointmentDeleted={onRowRemoved}
                    onAppointmentFormOpening={onAppointmentFormOpening}
                    onAppointmentAdding={onRowInserted}
                    dataCellTemplate={dataCellTemplate}
                    firstDayOfWeek={0}
                    onOptionChanged={onOptionChanged}
                    customizeDateNavigatorText={customizeDateNavigatorText}
                    crossScrollingEnabled={false}
                    onAppointmentRendered={onAppointmentRendered}
                    //appointmentTooltipComponent={toolTipComp}
                    appointmentTooltipRender={appointmentTooltip}

                >
                </Scheduler>
            }
        </div>
    );
}